var _defs, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNetworkError = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 497.164,
  height: 250.257
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-4{fill:#dbdbdb}.cls-6{fill:#c60018}.cls-7{fill:#fff}.cls-8{fill:#e8505b}.cls-9{opacity:.6}.cls-10{fill:#263238}.cls-12{fill:#29abe2}"))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1907",
  "data-name": "Group 1907",
  transform: "translate(-366 -176)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1906",
  "data-name": "Group 1906",
  transform: "translate(366 176)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Stains",
  transform: "translate(8.628 .691)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1818",
  "data-name": "Group 1818"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1817",
  "data-name": "Group 1817",
  style: {
    opacity: 0.7
  }
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1816",
  "data-name": "Group 1816"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13556",
  "data-name": "Path 13556",
  d: "M68.472 208.452c-3.2-18.472 3.217-38.885 17.967-50.458s37.659-12.434 51.945-.292c10.044 8.537 14.747 21.57 20.728 33.317s15.051 23.642 28.076 25.668c11.237 1.749 22.536-4.4 33.811-2.921 11.008 1.44 20.227 10.443 23.394 21.083s.8 22.454-4.88 31.992-14.421 16.965-23.99 22.592c-30.786 18.107-71.639 17.517-101.889-1.469s-48.544-55.52-45.624-91.116",
  transform: "translate(-67.667 -148.95)",
  style: {
    fill: "#ccc",
    opacity: 0.29
  }
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1819",
  "data-name": "Group 1819",
  transform: "translate(115.336 172.868)",
  style: {
    opacity: 0.58
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Path_13557",
  "data-name": "Path 13557",
  className: "cls-4",
  d: "M269.436 427.345c9.993-6.824 14.7-21.872 8.445-32.233-6.329-9.433-16.152-16.953-27.4-18.537s-23.681 3.725-28.688 13.917a26.163 26.163 0 0 0-.546 20.831 33.1 33.1 0 0 0 13.829 15.9c10.36 6.249 24.366 6.947 34.36.122z",
  transform: "translate(-219.352 -376.299)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1821",
  "data-name": "Group 1821",
  transform: "translate(330.474 124.976)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1820",
  "data-name": "Group 1820"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13558",
  "data-name": "Path 13558",
  d: "M660.313 361.609c-.621-16-8.549-31.875-21.823-40.835s-31.763-10.181-45.443-1.855c-8.521 5.185-14.707 13.447-19.854 21.991-2.819 4.682-5.765 9.846-10.831 11.894-6.592 2.666-13.839-.969-20.813-2.361a32.738 32.738 0 0 0-38.033 23.526c-6.1 25.234 11.606 43.255 30.526 54.187 21.15 12.221 47.87 12.211 70.895 4.055 15.1-5.348 29.165-14.141 39.444-26.422s16.554-28.176 15.932-44.18z",
  transform: "translate(-502.293 -313.314)",
  style: {
    fill: "#c1c1c1"
  }
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_1823",
  "data-name": "Group 1823",
  transform: "translate(389.247 13.439)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1822",
  "data-name": "Group 1822"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13559",
  "data-name": "Path 13559",
  className: "cls-4",
  d: "M642.49 189.735c-1.955-12.774-14.272-24.253-27.137-23.02-12.005 1.737-23.783 7.722-30.5 17.821s-7.353 24.519.15 34.051a27.938 27.938 0 0 0 19.805 10.147 35.352 35.352 0 0 0 21.693-5.973c10.799-7.088 17.943-20.251 15.989-33.026z",
  transform: "translate(-579.589 -166.624)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Character_2",
  "data-name": "Character 2",
  transform: "translate(232.902 56.558)"
}, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1825",
  "data-name": "Group 1825",
  transform: "translate(53.654 46.784)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1824",
  "data-name": "Group 1824"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13560",
  "data-name": "Path 13560",
  className: "cls-6",
  d: "M571.909 353.465a15.564 15.564 0 0 1-4.485-.649c-14.451-4.326-13.7-14.75-13.1-23.126.563-7.813.582-12.723-5.861-15.14-8.518-3.2-12.03-.094-17.339 4.6-6.325 5.6-14.193 12.56-33.277 9.735-9.915-1.468-25.84-6.693-45.4-23.25a155.755 155.755 0 0 1-19.264-19.316l2.955-2.369c.291.363 29.482 36.336 62.261 41.189 17.337 2.569 24.178-3.485 30.213-8.825 5.413-4.789 10.526-9.311 21.18-5.315 9.419 3.534 8.829 11.729 8.308 18.959-.609 8.463-1.136 15.771 10.406 19.226 13 3.9 30.106-16.706 40.326-29.013 3.646-4.39 6.183-7.568 8.2-9.214l2.861 2.271c-1.264 1.55-4.777 5.3-8.151 9.363-10.405 12.541-25.63 30.872-39.833 30.874z",
  transform: "translate(-433.187 -283.953)"
})))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1827",
  "data-name": "Group 1827",
  transform: "translate(125.103 86.317)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1826",
  "data-name": "Group 1826"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13561",
  "data-name": "Path 13561",
  className: "cls-7",
  d: "M540.828 335.949c.013.022-.148.141-.451.338a13.487 13.487 0 0 1-1.337.748 19.968 19.968 0 0 1-9.816 2.027 13.292 13.292 0 0 1-1.524-.157 1.67 1.67 0 0 1-.548-.131c.008-.062.8.018 2.079.024a23.71 23.71 0 0 0 9.7-2c1.169-.515 1.869-.898 1.897-.849z",
  transform: "translate(-527.153 -335.945)"
})))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1829",
  "data-name": "Group 1829",
  transform: "translate(153.35 74.544)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1828",
  "data-name": "Group 1828"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13562",
  "data-name": "Path 13562",
  className: "cls-7",
  d: "M571.965 320.8a8.516 8.516 0 0 1-1.242-.041 8.456 8.456 0 0 0-5.464 1.883c-.589.477-.9.837-.953.8a2.824 2.824 0 0 1 .779-1 7.311 7.311 0 0 1 5.653-1.948 2.828 2.828 0 0 1 1.227.306z",
  transform: "translate(-564.303 -320.462)"
})))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1831",
  "data-name": "Group 1831",
  transform: "translate(177.373 102.308)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1830",
  "data-name": "Group 1830"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13563",
  "data-name": "Path 13563",
  className: "cls-7",
  d: "M603.755 365.465a5.032 5.032 0 0 1-1.708-.527 10.991 10.991 0 0 1-5.75-6.218 5.019 5.019 0 0 1-.391-1.744c.063-.014.215.649.637 1.647a12.246 12.246 0 0 0 5.619 6.077c.962.5 1.612.7 1.593.765z",
  transform: "translate(-595.896 -356.976)"
})))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1833",
  "data-name": "Group 1833",
  transform: "translate(232.184 75.157)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1832",
  "data-name": "Group 1832"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13564",
  "data-name": "Path 13564",
  className: "cls-7",
  d: "M673.973 321.271a48.078 48.078 0 0 1-5.989 5.979 47.8 47.8 0 0 1 5.989-5.979z",
  transform: "translate(-667.981 -321.268)"
})))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1835",
  "data-name": "Group 1835",
  transform: "translate(44.163 37.754)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1834",
  "data-name": "Group 1834"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13565",
  "data-name": "Path 13565",
  className: "cls-8",
  d: "M433.551 284.314a4.371 4.371 0 0 1-6.175.3l-6.671-6.062 5.88-6.47 6.671 6.063a4.37 4.37 0 0 1 .295 6.169z",
  transform: "translate(-420.705 -272.077)"
})))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1844",
  "data-name": "Group 1844"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1836",
  "data-name": "Group 1836",
  transform: "translate(10.999 .187)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13566",
  "data-name": "Path 13566",
  className: "cls-8",
  d: "m389.367 235.946-11.51-9.518a2.123 2.123 0 0 1-.283-2.988 2.123 2.123 0 0 1 2.988-.283l11.51 9.518z",
  transform: "translate(-377.088 -222.67)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1837",
  "data-name": "Group 1837",
  transform: "translate(.183 14.09)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13567",
  "data-name": "Path 13567",
  className: "cls-8",
  d: "m375.144 254.232-11.51-9.518a2.122 2.122 0 0 1-.283-2.988 2.122 2.122 0 0 1 2.987-.283l11.51 9.518z",
  transform: "translate(-362.864 -240.956)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1838",
  "data-name": "Group 1838",
  className: "cls-9",
  transform: "translate(10.999 .187)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13568",
  "data-name": "Path 13568",
  className: "cls-7",
  d: "m389.367 235.946-11.51-9.518a2.123 2.123 0 0 1-.283-2.988 2.123 2.123 0 0 1 2.988-.283l11.51 9.518z",
  transform: "translate(-377.088 -222.67)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1839",
  "data-name": "Group 1839",
  className: "cls-9",
  transform: "translate(.183 14.09)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13569",
  "data-name": "Path 13569",
  className: "cls-7",
  d: "m375.144 254.232-11.51-9.518a2.122 2.122 0 0 1-.283-2.988 2.122 2.122 0 0 1 2.987-.283l11.51 9.518z",
  transform: "translate(-362.864 -240.956)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1841",
  "data-name": "Group 1841",
  transform: "translate(10.815)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1840",
  "data-name": "Group 1840"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13570",
  "data-name": "Path 13570",
  className: "cls-10",
  d: "M389.309 235.887a1.891 1.891 0 0 1 .178-.251l.515-.667 1.924-2.426.015.16c-1.445-1.176-3.289-2.676-5.405-4.4l-3.385-2.781-1.817-1.5-.934-.77a1.961 1.961 0 0 0-1.016-.441 1.935 1.935 0 0 0-2.112 2.39 1.872 1.872 0 0 0 .408.794 6.912 6.912 0 0 0 .7.618l1.426 1.189 4.93 4.147 3.338 2.841.914.793a2.936 2.936 0 0 1 .322.3 1.956 1.956 0 0 1-.316-.226l-.917-.722-3.4-2.728-5.057-4.107-1.461-1.2a6.949 6.949 0 0 1-.751-.664 2.22 2.22 0 0 1-.49-.941 2.3 2.3 0 0 1 2.512-2.851 2.328 2.328 0 0 1 1.209.525l.932.772 1.812 1.5 3.366 2.8 5.337 4.482.089.075-.074.086-2.064 2.4-.541.612c-.122.137-.185.204-.187.191z",
  transform: "translate(-376.847 -222.425)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1843",
  "data-name": "Group 1843",
  transform: "translate(0 13.904)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1842",
  "data-name": "Group 1842"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13571",
  "data-name": "Path 13571",
  className: "cls-10",
  d: "M375.086 254.173a1.788 1.788 0 0 1 .177-.251l.516-.667 1.924-2.426.015.16-5.4-4.4-3.386-2.781-1.817-1.5-.934-.77a1.937 1.937 0 0 0-3.127 1.949 1.873 1.873 0 0 0 .408.794 6.813 6.813 0 0 0 .7.617l1.426 1.19 4.931 4.147 3.337 2.841.914.792a3.136 3.136 0 0 1 .322.3 1.857 1.857 0 0 1-.316-.227l-.918-.722-3.4-2.728-5.06-4.115-1.461-1.2a6.931 6.931 0 0 1-.751-.663 2.237 2.237 0 0 1-.49-.941 2.3 2.3 0 0 1 2.513-2.851 2.329 2.329 0 0 1 1.208.525l.932.772 1.812 1.5 3.367 2.8 5.336 4.483.089.075-.074.086-2.064 2.4-.542.611c-.123.146-.186.211-.187.2z",
  transform: "translate(-362.623 -240.711)"
}))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1845",
  "data-name": "Group 1845",
  transform: "translate(7.96 5.314)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13572",
  "data-name": "Path 13572",
  className: "cls-6",
  d: "m414.566 249.6.3-.367a4.066 4.066 0 0 0-5.653-5.783l-16.85-14.034-19.276 23.061 17.243 13.712a4.065 4.065 0 0 0 .827 5.332 4.064 4.064 0 0 0 5.658-.469 11.728 11.728 0 0 0 16.209-2.031l2.767-3.455a11.724 11.724 0 0 0-1.225-15.966z",
  transform: "translate(-373.092 -229.413)"
}))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1847",
  "data-name": "Group 1847",
  transform: "translate(7.695 5.086)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1846",
  "data-name": "Group 1846"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13573",
  "data-name": "Path 13573",
  className: "cls-10",
  d: "M414.482 249.525a1.583 1.583 0 0 1 .147.132l.4.386a5.557 5.557 0 0 1 .614.672l.378.452.38.557a11.143 11.143 0 0 1 1.485 3.171 11.732 11.732 0 0 1-1.692 10.134c-.617.878-1.334 1.7-2.035 2.607a22.784 22.784 0 0 1-2.329 2.689 11.736 11.736 0 0 1-7.043 3.115 11.9 11.9 0 0 1-8.156-2.328l.23-.024a4.243 4.243 0 0 1-5.9.494l-.012-.011.012.011a4.251 4.251 0 0 1-.866-5.567l.04.24-13.347-10.606-3.9-3.1-.15-.119.122-.147 19.3-23.046.1-.124.123.1 16.817 14.08h-.135a4.181 4.181 0 0 1 2.651-.884 4.138 4.138 0 0 1 4.056 4.188 4.041 4.041 0 0 1-.751 2.292 5.487 5.487 0 0 1-.392.478 1.931 1.931 0 0 1-.149.159c-.02 0 .182-.225.493-.67a4.057 4.057 0 0 0 .685-2.26 4.015 4.015 0 0 0-1.693-3.267 3.974 3.974 0 0 0-4.768.131l-.068.053-.067-.056-16.885-13.991.227-.021-19.256 23.078-.027-.266 3.9 3.1 13.341 10.615.129.1-.09.138a3.894 3.894 0 0 0 .786 5.1l.012.011-.012-.011a3.872 3.872 0 0 0 2.868.871 3.917 3.917 0 0 0 2.549-1.315l.1-.119.126.1a11.588 11.588 0 0 0 7.927 2.286 11.45 11.45 0 0 0 6.878-3.01 22.508 22.508 0 0 0 2.315-2.647c.7-.895 1.436-1.732 2.042-2.584a11.591 11.591 0 0 0 1.741-9.948 11.218 11.218 0 0 0-1.425-3.156l-.366-.56-.364-.457a6.343 6.343 0 0 0-.6-.7l-.382-.408a1.074 1.074 0 0 1-.114-.138z",
  transform: "translate(-372.743 -229.113)"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1848",
  "data-name": "Group 1848",
  transform: "translate(16.33 16.138)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_845",
  "data-name": "Rectangle 845",
  transform: "rotate(39.56 .963 2.678)",
  style: {
    fill: "#e0e0e0"
  },
  d: "M0 0h15.424v3.022H0z"
})), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1850",
  "data-name": "Group 1850",
  transform: "translate(31.6 25.497)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1849",
  "data-name": "Group 1849"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13574",
  "data-name": "Path 13574",
  className: "cls-10",
  d: "M422.016 255.958a6.12 6.12 0 0 1-.633.9c-.426.566-1.058 1.374-1.847 2.365-1.579 1.981-3.806 4.68-6.293 7.637l-6.375 7.566-1.939 2.287a6.166 6.166 0 0 1-.747.811 6.328 6.328 0 0 1 .633-.9c.427-.566 1.058-1.374 1.848-2.364 1.579-1.982 3.806-4.681 6.293-7.639l6.375-7.565 1.938-2.288a6.292 6.292 0 0 1 .747-.81z",
  transform: "translate(-404.181 -255.957)"
})))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1852",
  "data-name": "Group 1852",
  transform: "translate(24.931 19.347)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1851",
  "data-name": "Group 1851"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13575",
  "data-name": "Path 13575",
  className: "cls-10",
  d: "M414.566 247.87a7.081 7.081 0 0 1-.689.945c-.462.594-1.143 1.442-1.993 2.483a503.657 503.657 0 0 1-6.752 8.045l-6.836 7.974-2.083 2.406a6.918 6.918 0 0 1-.8.852 7.005 7.005 0 0 1 .688-.945c.462-.594 1.143-1.442 1.994-2.483 1.7-2.083 4.089-4.926 6.753-8.046l6.834-7.973 2.084-2.406a6.986 6.986 0 0 1 .8-.852z",
  transform: "translate(-395.412 -247.869)"
}))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
  id: "Character_1",
  "data-name": "Character 1"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1869",
  "data-name": "Group 1869"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1854",
  "data-name": "Group 1854"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1853",
  "data-name": "Group 1853"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13576",
  "data-name": "Path 13576",
  className: "cls-12",
  d: "M152.478 282.54a45.76 45.76 0 0 1-9.83-1.067c-6.711-1.474-11.962-3.64-16-6.608a50.854 50.854 0 0 1-15.551 2.828c-17.247.464-32.851-4.927-51.994-20.421a101.888 101.888 0 0 1-2.781-6.532c18.422 14.911 38.369 23.6 54.674 23.167a47.426 47.426 0 0 0 12.329-1.943c-4.45-4.637-6.687-10.7-6.66-18.055.03-8.073 3.463-11.728 6.339-13.373 4.071-2.33 9.634-2.01 14.515.834a16.435 16.435 0 0 1 8.563 14.2 15.63 15.63 0 0 1-6.141 12.143 46.589 46.589 0 0 1-9.043 5.434 45.018 45.018 0 0 0 30.089 4.756c16.2-3.216 29.736-8.965 40.221-17.087a65.348 65.348 0 0 0 25.492-53.804v-.07c-.931-18.741-11.877-37.05-27.885-46.645-13.89-8.325-31.681-10.608-50.094-6.424-11.446 2.6-27.017 8.769-36.2 23.39-9.886 15.749-7.2 35.3.949 44.389 5.819 6.484 16.968 4.146 25.927 2.268 1.012-.212 2-.418 2.952-.608 9.638-1.915 48.726-20.249 48.877-20.3l.828 3.116c-.626.221-39.063 18.933-48.967 20.9-.941.186-1.914.391-2.913.6-9.91 2.077-22.246 4.663-29.523-3.445-5.266-5.867-8.192-14.336-8.242-23.847a47.9 47.9 0 0 1 6.9-25.085c9.87-15.722 26.42-22.311 38.565-25.07 19.367-4.4 38.149-1.96 52.88 6.869 17.052 10.221 28.714 29.717 29.719 49.673a69.126 69.126 0 0 1-26.948 57.092c-10.954 8.485-25.018 14.477-41.8 17.807a47.426 47.426 0 0 1-9.247.918zm-23.352-39.772a8.489 8.489 0 0 0-4.243 1.056c-2.881 1.648-4.414 5.142-4.432 10.1-.027 7.089 2.2 12.576 6.86 16.649a43.338 43.338 0 0 0 10.31-5.852 11.817 11.817 0 0 0 4.672-9.164 12.7 12.7 0 0 0-6.682-10.915 13.058 13.058 0 0 0-6.485-1.875z",
  transform: "translate(-56.32 -148.041)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1856",
  "data-name": "Group 1856",
  transform: "translate(65.242 121.865)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1855",
  "data-name": "Group 1855"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13577",
  "data-name": "Path 13577",
  className: "cls-10",
  d: "M150.268 315.238a4.511 4.511 0 0 1-1.428-.691 26.6 26.6 0 0 1-3.079-2.258 24.228 24.228 0 0 1-2.743-2.661 4.144 4.144 0 0 1-.89-1.314c.048-.03.4.449 1.085 1.135s1.661 1.6 2.788 2.553 2.194 1.766 2.984 2.324a12.779 12.779 0 0 1 1.283.912z",
  transform: "translate(-142.124 -308.313)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1858",
  "data-name": "Group 1858",
  transform: "translate(68.099 119.421)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1857",
  "data-name": "Group 1857"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13578",
  "data-name": "Path 13578",
  className: "cls-10",
  d: "M155.148 312.249a4.67 4.67 0 0 1-1.709-.434 14.324 14.324 0 0 1-3.649-2.186 17.852 17.852 0 0 1-2.977-3.034 5.62 5.62 0 0 1-.929-1.495 15.176 15.176 0 0 1 1.134 1.328 23.352 23.352 0 0 0 3.007 2.908 17.494 17.494 0 0 0 3.518 2.235c.97.453 1.619.615 1.605.678z",
  transform: "translate(-145.881 -305.098)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1860",
  "data-name": "Group 1860",
  transform: "translate(61.088 97.121)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1859",
  "data-name": "Group 1859"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13579",
  "data-name": "Path 13579",
  className: "cls-7",
  d: "M137.759 292.119a2.22 2.22 0 0 1-.238-.617 15.56 15.56 0 0 1-.439-1.745 22.551 22.551 0 0 1 .821-11.74 15.593 15.593 0 0 1 .679-1.667 2.249 2.249 0 0 1 .322-.578c.058.026-.31.887-.749 2.327a25.857 25.857 0 0 0-.813 11.612c.234 1.489.478 2.389.417 2.408z",
  transform: "translate(-136.66 -275.771)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1862",
  "data-name": "Group 1862",
  transform: "translate(40.392 125.324)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1861",
  "data-name": "Group 1861"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13580",
  "data-name": "Path 13580",
  className: "cls-7",
  d: "M121.775 314.619a6.721 6.721 0 0 1-1.832.316 19.96 19.96 0 0 1-8.83-1.253 6.707 6.707 0 0 1-1.671-.814 14.2 14.2 0 0 1 1.759.564 25.138 25.138 0 0 0 8.727 1.238 14.186 14.186 0 0 1 1.847-.051z",
  transform: "translate(-109.442 -312.862)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1864",
  "data-name": "Group 1864",
  transform: "translate(148.111 101.883)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1863",
  "data-name": "Group 1863"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13581",
  "data-name": "Path 13581",
  className: "cls-7",
  d: "M260.551 282.035a8.875 8.875 0 0 1-1.11 1.656 40.221 40.221 0 0 1-6.7 6.877 8.879 8.879 0 0 1-1.627 1.153 12.825 12.825 0 0 1 1.456-1.354c.915-.815 2.157-1.962 3.461-3.3s2.416-2.608 3.207-3.543a12.913 12.913 0 0 1 1.313-1.489z",
  transform: "translate(-251.109 -282.033)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1866",
  "data-name": "Group 1866",
  transform: "translate(46.926 36.27)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1865",
  "data-name": "Group 1865"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13582",
  "data-name": "Path 13582",
  className: "cls-7",
  d: "M120.21 222.617a5.968 5.968 0 0 1-.386-1.008 28.782 28.782 0 0 1-.8-2.835 37.469 37.469 0 0 1-.747-4.307 38.419 38.419 0 0 1 .281-10.684 37.4 37.4 0 0 1 .972-4.263 28.822 28.822 0 0 1 .947-2.788 5.963 5.963 0 0 1 .439-.987 5.934 5.934 0 0 1-.3 1.036 42.729 42.729 0 0 0-.83 2.81 42.454 42.454 0 0 0-.887 4.247 41.309 41.309 0 0 0-.279 10.592 42.537 42.537 0 0 0 .662 4.288c.252 1.21.49 2.185.681 2.85a5.928 5.928 0 0 1 .247 1.049z",
  transform: "translate(-118.035 -195.743)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1868",
  "data-name": "Group 1868",
  transform: "translate(51.511 29.014)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1867",
  "data-name": "Group 1867"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13583",
  "data-name": "Path 13583",
  className: "cls-7",
  d: "M126.254 186.2a13.28 13.28 0 0 1-2.177 3.875 13.279 13.279 0 0 1 2.177-3.875z",
  transform: "translate(-124.065 -186.199)"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1870",
  "data-name": "Group 1870",
  transform: "translate(132.188 22.215)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13584",
  "data-name": "Path 13584",
  className: "cls-12",
  d: "m285.419 214.11-6.759-34.744a2.605 2.605 0 0 0-5.114 1l.307 1.578-13.982 3.441a9.331 9.331 0 0 0-6.529 5.827l-8.434 2.075a5.448 5.448 0 0 0-3.989 6.592l.757 3.079-8.254 2.031a4.272 4.272 0 1 0 2.041 8.3l8.255-2.031.586 2.383a5.448 5.448 0 0 0 6.592 3.989l8.587-2.112-.015-.064a9.322 9.322 0 0 0 8.284 1.966l12.408-3.053.145.747a2.6 2.6 0 0 0 5.113-1z",
  transform: "translate(-230.169 -177.258)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1872",
  "data-name": "Group 1872",
  transform: "translate(133.415 23.242)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1871",
  "data-name": "Group 1871"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13585",
  "data-name": "Path 13585",
  className: "cls-10",
  d: "M287.211 215.615a1.975 1.975 0 0 1 .067.586 2.593 2.593 0 0 1-.594 1.61 2.663 2.663 0 0 1-2.568.915 2.716 2.716 0 0 1-1.541-.927 2.634 2.634 0 0 1-.481-.888c-.1-.341-.147-.678-.223-1.032l.1.065-9.112 2.276-2.726.678a10.638 10.638 0 0 1-2.972.417 9.5 9.5 0 0 1-6-2.254l.233-.144.015.063.035.14-.14.034c-2.9.7-5.931 1.508-9.2 2.241a5.626 5.626 0 0 1-4.767-1.672A5.5 5.5 0 0 1 246 215.4c-.238-.866-.434-1.728-.656-2.606l.207.125-6.959 1.718c-.6.137-1.168.319-1.816.413a4.452 4.452 0 0 1-4.384-6.665 4.655 4.655 0 0 1 3.262-2.2l7.77-1.913-.137.226-.481-1.951a13.118 13.118 0 0 1-.421-2.075 5.631 5.631 0 0 1 2.926-5.343 7.394 7.394 0 0 1 1.974-.682l7.805-1.918-.129.115a9.624 9.624 0 0 1 3.937-4.8 9.819 9.819 0 0 1 2.84-1.166l2.888-.708 10.98-2.69-.122.192-.24-1.235a3.321 3.321 0 0 1-.081-1.29 2.759 2.759 0 0 1 5.413-.214l1.662 8.6 2.687 14.012 1.713 9.049.44 2.391.106.615a1.2 1.2 0 0 1 .027.21 1.3 1.3 0 0 1-.053-.2l-.132-.611-.49-2.381c-.42-2.1-1.03-5.156-1.8-9.032l-2.762-14-1.691-8.583a2.445 2.445 0 0 0-4.8.193 2.985 2.985 0 0 0 .083 1.179l.242 1.235.03.154-.153.038-10.974 2.711c-1.89.525-3.93.756-5.623 1.839a9.266 9.266 0 0 0-3.782 4.622l-.033.091-.1.024-7.8 1.922a7.048 7.048 0 0 0-1.885.648 5.259 5.259 0 0 0-2.73 4.989 12.824 12.824 0 0 0 .411 2.012l.48 1.952.045.182-.182.044-7.771 1.911a4.274 4.274 0 0 0-3.032 2.023 4.09 4.09 0 0 0 4.022 6.126c.575-.081 1.187-.269 1.776-.4l6.962-1.706.165-.041.042.166c.219.872.418 1.754.647 2.594a5.175 5.175 0 0 0 1.257 2.185 5.3 5.3 0 0 0 4.488 1.586c3.2-.711 6.285-1.516 9.173-2.205l-.106.173-.015-.063-.106-.432.338.288a9.225 9.225 0 0 0 5.814 2.212 10.365 10.365 0 0 0 2.909-.395l2.725-.66 9.128-2.213.084-.02.017.085c.072.349.122.7.21 1.017a2.474 2.474 0 0 0 .445.842 2.563 2.563 0 0 0 4.545-1.506c.019-.391-.029-.588-.018-.59z",
  transform: "translate(-231.782 -178.609)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1874",
  "data-name": "Group 1874",
  transform: "translate(176.968 28.139)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1873",
  "data-name": "Group 1873"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13586",
  "data-name": "Path 13586",
  className: "cls-10",
  d: "M295.983 217.344c-.1.021-1.732-7.191-3.641-16.108s-3.378-16.166-3.276-16.187 1.731 7.189 3.642 16.109 3.376 16.164 3.275 16.186z",
  transform: "translate(-289.06 -185.049)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1876",
  "data-name": "Group 1876",
  transform: "translate(156.778 37.298)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1875",
  "data-name": "Group 1875"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13587",
  "data-name": "Path 13587",
  className: "cls-10",
  d: "M268.622 221.381c-.1.025-1.549-5.392-3.236-12.1s-2.973-12.164-2.873-12.189 1.549 5.39 3.236 12.1 2.973 12.163 2.873 12.189z",
  transform: "translate(-262.508 -197.094)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1878",
  "data-name": "Group 1878",
  transform: "translate(145.09 49.091)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1877",
  "data-name": "Group 1877"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13588",
  "data-name": "Path 13588",
  className: "cls-10",
  d: "M249.189 220.9a18.777 18.777 0 0 1-1.2-4.107 35.489 35.489 0 0 1-.838-4.19 18.786 18.786 0 0 1 1.2 4.107 35.56 35.56 0 0 1 .838 4.19z",
  transform: "translate(-247.137 -212.604)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1880",
  "data-name": "Group 1880",
  transform: "translate(145.306 39.325)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1879",
  "data-name": "Group 1879"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13589",
  "data-name": "Path 13589",
  className: "cls-7",
  d: "M256.755 199.779a20.218 20.218 0 0 1-2.122.452c-.652.138-1.429.313-2.277.547a11.533 11.533 0 0 0-2.631 1.038 3.622 3.622 0 0 0-1.847 1.939 5.7 5.7 0 0 0-.048 2.269c.169 1.32.389 2.122.332 2.137a7.078 7.078 0 0 1-.593-2.1 5.583 5.583 0 0 1-.022-2.4 2.781 2.781 0 0 1 .757-1.254 6.15 6.15 0 0 1 1.236-.914 10.953 10.953 0 0 1 2.728-1.046 26.448 26.448 0 0 1 2.318-.474 9.111 9.111 0 0 1 2.169-.194z",
  transform: "translate(-247.42 -199.76)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1882",
  "data-name": "Group 1882",
  transform: "translate(158.487 30.118)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1881",
  "data-name": "Group 1881"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13590",
  "data-name": "Path 13590",
  className: "cls-7",
  d: "M280.916 187.66a2.944 2.944 0 0 1-.72.217c-.468.116-1.148.271-1.991.456l-6.585 1.385a13.866 13.866 0 0 0-3.443 1.2 7.18 7.18 0 0 0-2.271 1.87 6.3 6.3 0 0 0-1.136 2.473 1.907 1.907 0 0 1 .059-.754 5.066 5.066 0 0 1 .865-1.879 7.123 7.123 0 0 1 2.318-2.013 13.413 13.413 0 0 1 3.523-1.267c2.583-.554 4.92-.967 6.618-1.28a85.33 85.33 0 0 1 2.013-.339 2.921 2.921 0 0 1 .75-.069z",
  transform: "translate(-264.755 -187.651)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1884",
  "data-name": "Group 1884",
  transform: "translate(134.425 50.976)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1883",
  "data-name": "Group 1883"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13591",
  "data-name": "Path 13591",
  className: "cls-7",
  d: "M242.339 215.091a3.693 3.693 0 0 1-1.468.584c-.948.256-2.3.364-3.717.665a7.62 7.62 0 0 0-1.911.668 4.866 4.866 0 0 0-1.3.994 6.655 6.655 0 0 0-.823 1.288 2.278 2.278 0 0 1 .62-1.459 4.639 4.639 0 0 1 1.335-1.125 7.187 7.187 0 0 1 2-.731c1.47-.31 2.8-.373 3.743-.559.94-.164 1.499-.377 1.521-.325z",
  transform: "translate(-233.11 -215.083)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1886",
  "data-name": "Group 1886",
  transform: "translate(177.45 24.097)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1885",
  "data-name": "Group 1885"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13592",
  "data-name": "Path 13592",
  className: "cls-7",
  d: "M292.578 179.845c-.005.058-.277.052-.679.161a2.546 2.546 0 0 0-1.937 2.271c-.044.414 0 .681-.052.7s-.189-.24-.213-.7a2.437 2.437 0 0 1 2.152-2.524c.463-.053.737.047.729.092z",
  transform: "translate(-289.694 -179.732)"
}))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
  id: "Lines",
  transform: "translate(193.83 7.068)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1905",
  "data-name": "Group 1905"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1888",
  "data-name": "Group 1888",
  transform: "translate(36.011 12.015)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1887",
  "data-name": "Group 1887"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13593",
  "data-name": "Path 13593",
  className: "cls-10",
  d: "M419.87 173.139a.578.578 0 0 1-.141.091l-.431.235-1.677.877-6.233 3.184-20.928 10.543-.141.071-.093-.132-1.826-2.583-2.6-3.68.245.053-19.5 11.264-5.812 3.312-1.577.879-.413.22a.54.54 0 0 1-.146.065.566.566 0 0 1 .129-.1l.4-.25 1.544-.935 5.754-3.41 19.439-11.37.147-.085.1.139 2.6 3.679 1.825 2.584-.233-.06 20.972-10.43 6.284-3.082 1.708-.817.447-.2a.6.6 0 0 1 .157-.062z",
  transform: "translate(-358.598 -173.138)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1890",
  "data-name": "Group 1890",
  transform: "translate(48.791 39.476)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1889",
  "data-name": "Group 1889"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13594",
  "data-name": "Path 13594",
  className: "cls-10",
  d: "M418.355 209.258a2.011 2.011 0 0 1-.414.115l-1.2.262-4.452.906-14.911 2.9-.185.036-.033-.187c-.1-.587-.216-1.212-.328-1.844l-.217-1.22.216.151a179.59 179.59 0 0 0-15.244 3.315c-1.918.5-3.459.935-4.523 1.236l-1.224.339a2.026 2.026 0 0 1-.434.1 2.045 2.045 0 0 1 .412-.166l1.206-.4c1.051-.342 2.583-.811 4.5-1.349A153.8 153.8 0 0 1 396.767 210l.183-.032.033.183.217 1.22.328 1.844-.219-.151 14.933-2.779 4.474-.792 1.214-.2a1.9 1.9 0 0 1 .425-.035z",
  transform: "translate(-375.406 -209.254)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1892",
  "data-name": "Group 1892",
  transform: "translate(31.776 13.089)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1891",
  "data-name": "Group 1891"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13595",
  "data-name": "Path 13595",
  className: "cls-10",
  d: "M362.017 174.552c.093.046-1.843 4.225-4.325 9.336s-4.568 9.218-4.661 9.172 1.842-4.224 4.325-9.336 4.568-9.217 4.661-9.172z",
  transform: "translate(-353.028 -174.552)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1894",
  "data-name": "Group 1894",
  transform: "translate(41.872 33.582)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1893",
  "data-name": "Group 1893"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13596",
  "data-name": "Path 13596",
  className: "cls-10",
  d: "M387.9 201.507c.03.1-4.782 1.591-10.745 3.333s-10.822 3.073-10.851 2.974 4.781-1.591 10.746-3.333 10.823-3.073 10.85-2.974z",
  transform: "translate(-366.306 -201.502)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1896",
  "data-name": "Group 1896",
  transform: "translate(23.637)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1895",
  "data-name": "Group 1895"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13597",
  "data-name": "Path 13597",
  className: "cls-10",
  d: "M344.947 157.337a4.963 4.963 0 0 1 .309.779l.77 2.22 2.621 7.853.076.227h-.241l-5.939-.119.187-.22.439 2.358c.973 5.358 1.853 10.206 2.5 13.779l.716 4.184.176 1.141a1.722 1.722 0 0 1 .036.4 1.611 1.611 0 0 1-.111-.389l-.245-1.128-.833-4.161c-.677-3.568-1.6-8.409-2.61-13.759-.15-.808-.3-1.6-.436-2.358l-.042-.226.229.006 5.938.151-.165.222-2.492-7.895-.68-2.249a4.786 4.786 0 0 1-.203-.816z",
  transform: "translate(-342.324 -157.337)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1898",
  "data-name": "Group 1898",
  transform: "translate(0 49.145)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1897",
  "data-name": "Group 1897"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13598",
  "data-name": "Path 13598",
  className: "cls-10",
  d: "M311.238 230.121c-.044-.094 3.813-1.994 8.615-4.243s8.73-4 8.774-3.9-3.812 1.993-8.616 4.244-8.73 3.993-8.773 3.899z",
  transform: "translate(-311.237 -221.97)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1900",
  "data-name": "Group 1900",
  transform: "translate(17.924 54.567)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1899",
  "data-name": "Group 1899"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13599",
  "data-name": "Path 13599",
  className: "cls-10",
  d: "M334.814 237.341a77.081 77.081 0 0 1 6.871-8.238 38.573 38.573 0 0 1-3.292 4.239 38.365 38.365 0 0 1-3.579 3.999z",
  transform: "translate(-334.811 -229.102)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1902",
  "data-name": "Group 1902",
  transform: "translate(27.586 55.879)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1901",
  "data-name": "Group 1901"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13600",
  "data-name": "Path 13600",
  className: "cls-10",
  d: "M347.529 263.866c-.1-.011.557-7.416 1.473-16.538s1.743-16.513 1.845-16.5-.557 7.414-1.473 16.539-1.743 16.509-1.845 16.499z",
  transform: "translate(-347.518 -230.826)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1904",
  "data-name": "Group 1904",
  transform: "translate(14.396 23.409)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1903",
  "data-name": "Group 1903"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13601",
  "data-name": "Path 13601",
  className: "cls-10",
  d: "M330.179 188.125a34.021 34.021 0 0 1 3.173 6.383 34.026 34.026 0 0 1-3.173-6.383z",
  transform: "translate(-330.17 -188.124)"
})))))))));
export { SvgNetworkError as ReactComponent };